<template>
<div>
  <div class="comment"
       :class="{'comment--reply': isReply}"
       :id="comment.id"
  >
    <div class="comment__header">
      <div class="comment__avatar col-auto">
        <common-avatar :user="comment.user" size="sm" />
      </div>
      <div class="comment__info q-px-md text-neutral-70 col">
        <div>
          {{ comment.user ? $fullName(comment.user) : 'Verwijderde gebruiker' }}
        </div>
        <div class="row items-center">
          <q-icon name="schedule" size="14px" color="neutral-70" class="q-mr-sm" aria-hidden="true" />
          {{ $formatDateTime(comment.created_at) }}
        </div>
      </div>
    </div>
    <div v-if="comment.rule_version_id" class="comment__sub-header">
      <template v-if="!comment.rule && (!comment.rule_version || !comment.rule_version.rule)">
        <i>Op verwijderde richtlijn</i>
      </template>
      <template v-else>
        <i>Op richtlijn
          <common-link
              class="display-inline"
              :label="ruleVersionLabel"
              :href="$route('project.rule.show', {project_id: comment.project_id, phase_id: comment.phase_id, rule_id: comment.rule_id})"
          />
        </i>
      </template>
    </div>
    <template v-else-if="comment.object_id">
      <template v-if="!comment.object">
        <i>Op verwijderd inrichtingselement</i>
      </template>
      <template v-else>
        <i>Op inrichtingselement
          <common-link
              class="display-inline"
              :label="comment.object.title"
              :href="$route('project.object.show', {project_id: comment.project_id, object_id: comment.object_id})"
          />
        </i>
      </template>
    </template>

    <div v-else-if="comment.phase_id" class="comment__sub-header">
      <template v-if="!comment.phase">
        <i>- op verwijderde fase</i>
      </template>
      <template v-else>
        <i>Op fase
          <common-link
              class="display-inline"
              :label="comment.phase.title"
              :href="$route('project.rule.index', {project_id: comment.project_id, phase_id: comment.phase_id})"
          />
        </i>
      </template>
    </div>
    <div v-if="status !== 'edit'">
      <div class="comment__content">
        {{ comment.current_body }}
      </div>
      <div class="comment__actions">
        <flat-button label="Beantwoorden" class="q-mr-sm" @click="replyToComment()" />
        <flat-button v-if="$can('update', 'comment')" label="Bewerken" @click="editComment" />
      </div>
    </div>
    <div v-if="status === 'edit'">
      <common-input name="body"
                    v-model="editable_body"
                    label="Typ hier"
                    type="textarea"
                    class="comment__content"
                    autofocus
      />
      <div class="comment__actions">
        <flat-button label="Opslaan" class="q-mr-sm" type="submit" @click="submitUpdate" />
        <flat-button label="Annuleren" type="reset" @click="cancelEdit" />
      </div>
    </div>
  </div>
  <div v-if="status === 'reply'">
    <comment-create v-model:createForm="showCreateForm" :current-user="currentUser"
                    :comment-user-name="$fullName(comment.user)" :project-id="projectId" :parent-id="parentId" />
  </div>
  <div class="comment-replies">
    <template v-for="reply in comment.replies" :key="comment.id">
      <template v-if="reply">
        <comment
            :comment="reply"
            is-reply
            :project-id="projectId"
            :current-user="currentUser"
        />
      </template>
    </template>
  </div>
</div>
</template>

<script>
import moment from 'moment'
import CommentCreate from '../comment/CommentCreate'
import { useProjectComents } from '../../stores/useProjectComments'

export default {
  components: {
    CommentCreate,
  },
  setup () {
    const projectComments = useProjectComents()
    return {
      projectComments,
    }
  },
  data () {
    return {
      status: 'show',
      parentId: null,
      editable_body: '',
      showCreateForm: false,
    }
  },
  props: {
    comment: {
      type: Object,
      default: null,
    },
    projectId: {
      type: Number,
    },
    isReply: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ruleVersionLabel () {
      if (this.comment.rule) {
        return this.comment.rule.code
      } else if (this.comment.rule_version && this.comment.rule_version.rule) {
        return this.comment.rule_version.rule.code
      }
    },
  },
  methods: {
    dateFormatted (date) {
      return moment(date).format('DD MMM Y')
    },
    replyToComment () {
      this.status = 'reply'
      this.showCreateForm = true
    },
    editComment () {
      this.status = 'edit'
    },
    cancelEdit () {
      this.status = 'show'
    },
    setEditableBody () {
      this.editable_body = this.comment.current_body
    },
    submitUpdate () {
      this.errors = {}

      axios.put(route('api.comment.update', this.comment.id), { editable_body: this.editable_body }).then(({ data }) => {
        this.projectComments.reload()
        this.cancelEdit()
      }).catch(error => {
        if (error.response.status === 422) {
          // TODO what do?
          console.log(error.response.data.errors)
        }
      })
    },
  },
  mounted () {
    this.parentId = this.comment.id

    if (this.comment.parent_id) {
      this.parentId = this.comment.parent_id
    }
    this.setEditableBody()
  },
}
</script>
